

class CustomerNotAssociatedController {
	/*@ngInject*/
	constructor(Auth, $state, $stateParams, User, Modal, $translate, $location, UserService, BranchService, $q, $scope, FuelSurchargeService) {
		this.Auth = Auth;
		this.User = User;
		this.Modal = Modal;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.$q = $q;
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$location = $location;
		this.permissions = this.Auth.permission();
		this.loading = false;
		this.customers = [];
		this.FuelSurchargeService = FuelSurchargeService;
		this.sortColumn = 'name';
		this.reverseSort = 0;
		this.page = 1
		this.total = 0
		this.pageLimit = 10
		this.maxPages = 10
		this._objectKeys = Object.keys;
		this.searchText = '';
		this.weekDays = {
			'serviceScheduleSun': 'Sun',
			'serviceScheduleMon': 'Mon',
			'serviceScheduleTue': 'Tue',
			'serviceScheduleWed': 'Wed',
			'serviceScheduleThu': 'Thu',
			'serviceScheduleFri': 'Fri',
			'serviceScheduleSat': 'Sat',
			'serviceScheduleHol': 'Hol'
		};
	}

	$onInit() {
		this.loadDataList()
	}

	search() {
		this.page = 1;
		this.loadDataList()
	}
	refresh() {
		this.loadDataList()
	}
	loadDataList() {
		this.loading = true;
		this.customers = [];
		this.FuelSurchargeService.fuelSurchagePendingCustomersFilters(this.searchText, (this.page - 1) * this.pageLimit, this.pageLimit, this.sortColumn, this.reverseSort)
			.then(({ data, count }) => {
				this.total = count;
				this.customers = data;
				if (this.customers && this.customers.length) {
					this.customers.reduce((prev, item) => {
						return prev.then(() => {
							item.serviceDays = [];
							Object.keys(this.weekDays).map((key) => {
								if (item[key]) {
									item.serviceDays.push(this.weekDays[key])
								}

							})
							return item
						})
					}, Promise.resolve())
						.then(() => {
							this.loading = false;
						})
				} else {
					this.loading = false;
				}

			})
			.catch((err) => {
				this.loading = false
				this.error = err.message
			})
	}
	sortData(column) {
		this.page = 1;
		this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
		this.sortColumn = column;
		this.loadDataList()
	}
	goToCustomer = (customerId) => {
		this.$state.go('customer.edit', ({
			id: customerId
		}))
	}
}

export default CustomerNotAssociatedController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/customer_not_associated/customer_not_associated.controller.js